module.exports = __webpack_public_path__ + "media/eat9.532465ec.mp4";